import { cn } from '@/shared/utils';

interface Props {
  className?: string;
}

export function RingSpinner({ className }: Props) {
  return (
    <div
      className={cn(
        'h-4 w-4 animate-spin rounded-full border-2 border-black border-t-transparent',
        className,
      )}
    />
  );
}
